// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1xIeT","rootSuccess":"CompleteLink_rootSuccess__mog2d","rootFailure":"CompleteLink_rootFailure__vTBA3","isDisabled":"CompleteLink_isDisabled__3i8k_"};